import React, { Fragment, useState, useEffect, useContext } from 'react';
import Traductor from '../Traductor';
import Button from '../bronson/Button';
import { withCookies } from 'react-cookie';
import { Portal } from 'react-portal';

import {
    formatPrice,
    formatNumber,
} from '../../js/components/shared/vehicleFunctions';
import Globals from '../../Globals';
import VehicleService from '../../services/VehicleService';
import { disableHTMLOverflow } from '../../Functions';

import ParseService from '../../services/ParseService';
import TransportService from '../../services/TransportService';
import UserService from '../../services/UserService';
import ModalIframe from './ModalIframe';
import Loading from '../bronson/Loading';
import { UserContext } from 'contexts/UserContext';

const VehicleRentingModality = ({
    cookies,
    vehicleParent,
    loadingRequest,
    disabled,
}) => {
    const { preferences } = useContext(UserContext);
    const t = new Traductor();

    const [startSimulator, setStartSimulator] = useState(false);
    const [priceExtraValue, setPriceExtraValue] = useState(0);
    const [dealerCode, setDealerCode] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [transportPrice, setTransportPrice] = useState(0);
    const [modalUrl, setModalUrl] = useState('');
    const [showModal, setShowModal] = useState(false);

    const [mensaje] = useState('');
    const [loading, setLoading] = useState(false);

    let optionsBtnTarificar = {
        class: 'c-btn--full c-btn--primary-b u-mt',
        text: t.getTraduction('Quote'),
        btnTypes: ['secondary'],
        disabled: loadingRequest || disabled,
    };
    useEffect(() => {
        setShowModal(false);
        setStartSimulator(false);
    }, []);

    useEffect(() => {
        if (startSimulator) {
            GetDealerCode();
        }
    }, [priceExtraValue]);

    useEffect(() => {
        if (startSimulator) {
            GetTransportPrice();
        }
    }, [dealerCode, zipCode]);

    useEffect(() => {
        if (startSimulator) {
            RentingVOCall();
        }
    }, [transportPrice]);

    const GetTransportPriceExtraValue = async () => {
        let GlobalVariable = {};
        GlobalVariable.VariableName = 'CNST_LIMPIEZA_RENTING_VO';
        await new UserService()
            .getGlobalVariable(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                GlobalVariable
            )
            .then(dataResponse => {
                if (
                    dataResponse != null &&
                    dataResponse != undefined &&
                    dataResponse.Result != null
                ) {
                    setPriceExtraValue(JSON.parse(dataResponse.Result));
                }
            })
            .catch(error => {
                //Error(error);
            });
    };

    const GetDealerCode = async () => {
        let data = {};
        if (!preferences.IncludeTransport) {
            data.IdUser = cookies
                .get(process.env.REACT_APP_USER_ID)
                .toUpperCase();
            await new UserService()
                .getDefaultDealer(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    data
                )
                .then(dataResponse => {
                    if (
                        dataResponse != null &&
                        dataResponse != undefined &&
                        dataResponse.Result != null
                    ) {
                        setZipCode(JSON.parse(dataResponse.Result).ZipCode);
                        setDealerCode(
                            JSON.parse(dataResponse.Result).DealerCode
                        );
                    }
                })
                .catch(error => {
                    //Error(error);
                });
        } else {
            data.DealerChannel = preferences.CodconsesionarierBuyer;
            await new UserService()
                .getDealerCode(
                    cookies.get(Globals.COOKIES.JWT).AccessToken,
                    data
                )
                .then(dataResponse => {
                    if (
                        dataResponse != null &&
                        dataResponse != undefined &&
                        dataResponse.Result != null
                    ) {
                        setDealerCode(
                            JSON.parse(dataResponse.Result).DealerCode
                        );
                    }
                })
                .catch(error => {
                    //Error(error);
                });
        }
    };

    const GetTransportPrice = async () => {
        let codigoPostal =
            preferences.ZipCode == null || preferences.ZipCode == ''
                ? zipCode
                : preferences.ZipCode;
        var calculatePriceTransportRequest = {
            VehicleId: vehicleParent.Id,
            OriginType: vehicleParent.OriginType,
            LocationId: vehicleParent.LocationId,
            OriginId: vehicleParent.OriginId,
            PostalCode: codigoPostal,
        };

        await new TransportService()
            .getTransportPrice(
                cookies.get(Globals.COOKIES.JWT).AccessToken,
                calculatePriceTransportRequest
            )
            .then(datapriceResponse => {
                if (
                    datapriceResponse != null &&
                    datapriceResponse != undefined &&
                    datapriceResponse.Result != null
                ) {
                    let dataTransportprice = new ParseService().Parse(
                        datapriceResponse.Result
                    );
                    setTransportPrice(dataTransportprice.TransportPrice);
                }
            })
            .catch(error => {
                //Error(error);
            });
    };

    const RentingVOCall = async () => {
        let bodyCall = {};
        let header = {};
        let vehicle = {};
        header.ReturnUrl = 'RentingVO';
        header.Action = 'A';
        header.Application = 'REMA';
        header.Control = 'RVO';
        header.Version = '1';

        vehicle.Type = 'VO';
        vehicle.Purpose = 'TU';
        vehicle.TMAIMGVE = vehicleParent.Tmaimg;
        vehicle.PffAmount = (vehicleParent.Pff * 100).toFixed();
        vehicle.ComDenom = vehicleParent.ModelLong;
        vehicle.InitKm = vehicleParent.Kms;
        vehicle.RegDate = vehicleParent.RegistrationDate;
        vehicle.Frame = vehicleParent.VIN;
        vehicle.NReg = vehicleParent.Plate;
        vehicle.Emi = vehicleParent.Co2;
        vehicle.EmiNEDC = vehicleParent.Co2;
        vehicle.Power = vehicleParent.CV;
        vehicle.Energy = vehicleParent.Energy;
        vehicle.Location = vehicleParent.OriginDescription;
        vehicle.VehicleId = vehicleParent.Id;
        vehicle.TransAmount = (transportPrice + parseInt(priceExtraValue))
            .toFixed(2)
            .replace('.', '');

        bodyCall.Header = header;
        bodyCall.Vehicle = vehicle;
        bodyCall.Dealer = {};
        bodyCall.DealerShip = {};
        bodyCall.Dealer.Code = dealerCode;
        bodyCall.DealerShip.Code = dealerCode;

        let baseUrl =
            Globals.RENTING_VO.BASE_URL +
            Globals.RENTING_VO.SIMULATOR.BASE_PATH +
            Globals.RENTING_VO.SIMULATOR.SIMULATOR_ACCESS;
        await new VehicleService()
            .getRentingVOSimulatorCall(
                baseUrl,
                bodyCall,
                cookies.get(Globals.COOKIES.JWT).AccessToken
            )
            .then(data => {
                if (
                    data != null &&
                    data != undefined &&
                    data.body.Result != null &&
                    data.body.Errors.length == 0
                ) {
                    setModalUrl(data.body.Result);
                } else if (data.body.Error.length > 0) {
                    setLoading(false);
                    disableHTMLOverflow(false);
                }
                openModal();
            })
            .catch(error => {
                setLoading(false);
                disableHTMLOverflow(false);
            });
    };
    const printRVOModal = () => {
        if (!showModal) return null;
        return (
            <Portal>
                <ModalIframe
                    url={modalUrl}
                    show={showModal}
                    closeModal={closeModalIframe}
                    mensaje={mensaje}
                ></ModalIframe>
            </Portal>
        );
    };

    const openModal = () => {
        setLoading(false);
        setShowModal(true);
    };

    const closeModalIframe = value => {
        setShowModal(false);
        disableHTMLOverflow(false);
        setStartSimulator(false);
        emptyHooks();
    };

    const startSimulationRVO = () => {
        setLoading(true);
        disableHTMLOverflow(true);
        setStartSimulator(true);
        GetTransportPriceExtraValue();
    };

    const emptyHooks = () => {
        setZipCode('');
        setDealerCode('');
        setTransportPrice(0);
        setPriceExtraValue(0);
    };

    return (
        <Fragment>
            <hr />
            <div className="o-layout">
                <div className="o-layout__item u-2/3">
                    <p className="rema-text-overflow--ellipsis u-mb-xsmall">
                        {t.getTraduction('RVO')}{' '}
                    </p>
                    <p className="u-h6 u-mb-none c-vehicle-buy-options__buy-price u-mb-none">
                        {formatPrice(vehicleParent.FeeRVO, true)} + IVA*
                    </p>
                </div>
                <div className="o-layout__item u-1/3 u-pl-none">
                    <Button
                        options={optionsBtnTarificar}
                        onClick={() => startSimulationRVO()}
                    ></Button>
                </div>
            </div>
            <div className="o-layout u-pt-xsmall">
                <div className="o-layout__item u-2/3">
                    <span className="u-text-fs-2">
                        {t
                            .getTraduction('RVO_legal')
                            .replace('{mesesCuota}', vehicleParent.MonthsQuota)
                            .replace(
                                '{KmCuota}',
                                formatNumber(vehicleParent.KmQuota)
                            )
                            .replace(
                                '{entradaCuota}',
                                formatPrice(
                                    formatNumber(vehicleParent.EntryQuota),
                                    true
                                )
                            )}
                    </span>
                </div>
            </div>
            {printRVOModal()}
            <Loading ariaBusy={loading}></Loading>
        </Fragment>
    );
};

export default withCookies(VehicleRentingModality);
